import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import watcherApi from '../../api/watcherApi';
import { AdminRecordInterface } from '../../store/watcher/adminsSlice';

const PREFIX = 'watcher';

export const adminsEntity = new schema.Entity('admins');
export const adminEntity = new schema.Entity('admin');

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      admin: AdminRecordInterface;
    }
  >(response.data.admin, adminEntity);
  return normalized.entities;
}

export const fetchAdmins = createAsyncThunk(
  `${PREFIX}_admins/fetchAdmins`,
  async () => {
    const response = await watcherApi.get('/onesky/admins');
    const normalized = normalize<
      any,
      {
        admins: { [key: string]: AdminRecordInterface };
      }
    >(response.data.admins, [adminsEntity]);

    return {
      admins: normalized.entities?.admins || {},
      ids: normalized.result
    };
  }
);

export const createAdmin = createAsyncThunk(
  `${PREFIX}_admins/createAdmin`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await watcherApi.post(`/onesky/admins`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateAdmin = createAsyncThunk(
  `${PREFIX}_admins/updateAdmin`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await watcherApi.patch(`/onesky/admins/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const destroyAdmin = createAsyncThunk(
  `${PREFIX}_admins/destroyAdmin`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await watcherApi.delete(`/onesky/admins/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
